import { useQuery } from "react-query";
import { Schedule } from "../../types/types";
import { api } from "../api";
import { types } from "../../constants";

interface GetSchedulesRes {
	data: Schedule[];
}

export const getSchedules = (): Promise<GetSchedulesRes> => {
	return api.get(`schedule`);
};

export const useSchedules = (options?: { then?: (x: GetSchedulesRes) => any }) => {
	const cacheKey: (string | Record<string, number | string | Date>)[] = [types.SCHEDULE, types.ALL];
	const query = useQuery(
		cacheKey,
		() =>
			getSchedules().then((unit) => {
				options && options.then && options.then(unit);
				return unit;
			}),
		{ staleTime: 1000 * 5 }
	);
	return query;
};
